import React from 'react';
import '../../styles/styles.css';
import HlsPlayer from "../../components/hlsplayer";

export default function kolhapur() {
  return (
    <div className="container mt-4">
        <div className="row">
            {/* Left Large Image Box */}
            <div className="col-md-4 box1">
            <img src="/images/kolhapur.jpeg" alt="Shri Mahalakshmi" />    
            </div>

            {/* Right Information Boxes */}
            <div className="col-md-8">
                <div className="Reg-box2">
                    <p><strong>Next Important Festival Date in Kolhapur<br />
    Dussehra Navratri<br />    
    <br />

  </strong></p>
  <p>Kolhapur Temple site for Live Darshan : <a href="https://www.mahalaxmikolhapur.com/home" target="_blank" rel="noopener noreferrer">
  Kolhapur Temple Website
</a>
</p> </div>
            </div>
        </div>

        {/* Bottom Full Width Description Box */}
        <div className="row mt-3">
            <div className="col-12 Desc-box3">
             <p>Mahalakshmi Temple (also known as Ambabai Mandir) is an important Hindu temple dedicated to Goddess Mahalakshmi, who is worshipped by locals as Ambabai. Goddess Mahalakshmi Ambabai is the consort of Lord Vishnu and it is customary among Hindus to visit Tirumala Venkateswara Temple, Kolhapur Mahalakshmi Temple and Padmavathi Temple as a yatra (pilgrimage). It is believed that visiting these temples as a pilgrimage helps achieve moksha (salvation). It is considered one of the three and a half Shaktipeethas in the Shakta tradition.</p>
            </div>
        </div>


        <div className="row mt-3">
                <div className="col-12">
                  <div className="Desc-box3">
                    <h2 className="live-header">Darshan Live Streaming</h2>
                    <div className="hls-container">
                      <HlsPlayer url="https://s122.ipcamlive.com/streams/7at617szhapweuq3p/stream.m3u8" 
                      fallbackImage="/images/kolhapur.jpeg" />
                    </div>
                  </div>
                </div>

    </div>
 </div>
  )
}

